<script setup>
import CompFormTextInput from "@/components/form/CompFormTextInput.vue";
import { computed, onMounted } from "vue";

const props = defineProps({
  data: Object,
});

const emit = defineEmits(["update"]);

const hoursCleaning = computed(() => {
  return props.data.hours_cleaning || 0;
});

const hoursCooking = computed(() => {
  return props.data.hours_cooking || 0;
});

const hoursTransport = computed(() => {
  return props.data.hours_transport || 0;
});

const hoursPersonalErrands = computed(() => {
  return props.data.hours_personal_errands || 0;
});

onMounted(() => {
  emit("update", {
    ...props.data,
    hours_cleaning: hoursCleaning.value,
    hours_cooking: hoursCooking.value,
    hours_transport: hoursTransport.value,
    hours_personal_errands: hoursPersonalErrands.value,
  });
});
</script>

<template>
  <section
    class="tw-rounded-xl lg:tw-rounded-2xl tw-border tw-border-gray-350 tw-p-4 tw-flex tw-flex-col tw-gap-2"
  >
    <div class="tw-flex tw-justify-between tw-items-center">
      <p class="tw-m-0 tw-font-robotoBold tw-text-xs lg:tw-text-sm">
        ¿Cuántas horas dedicas a la semana en diferentes tareas
        extracurriculares en tu hogar?*
      </p>
      <p class="tw-m-0 tw-font-robotoLight tw-text-xxs lg:tw-text-xs">
        *En caso de que no aplique, pon 0 en la respuesta
      </p>
    </div>
    <div class="tw-grid tw-grid-cols-3 tw-gap-2">
      <comp-form-text-input
        class="tw-col-span-1"
        :model-value="hoursCleaning"
        @update="
          (value) =>
            emit('update', { ...props.data, hours_cleaning: Number(value) })
        "
        input-type="number"
      />
      <div class="tw-col-span-2 tw-flex tw-items-center">
        <p class="tw-m-0 tw-font-roboto tw-text-sm">Limpieza del hogar</p>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-3 tw-gap-2">
      <comp-form-text-input
        class="tw-col-span-1"
        :model-value="hoursCooking"
        @update="
          (value) =>
            emit('update', { ...props.data, hours_cooking: Number(value) })
        "
        input-type="number"
      />
      <div class="tw-col-span-2 tw-flex tw-items-center">
        <p class="tw-m-0 tw-font-roboto tw-text-sm">Cocinar</p>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-3 tw-gap-2">
      <comp-form-text-input
        class="tw-col-span-1"
        :model-value="hoursTransport"
        @update="
          (value) =>
            emit('update', { ...props.data, hours_transport: Number(value) })
        "
        input-type="number"
      />
      <div class="tw-col-span-2 tw-flex tw-items-center">
        <p class="tw-m-0 tw-font-roboto tw-text-sm">
          Transportarse hasta lugar de residencia
        </p>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-3 tw-gap-2">
      <comp-form-text-input
        class="tw-col-span-1"
        :model-value="hoursPersonalErrands"
        @update="
          (value) =>
            emit('update', {
              ...props.data,
              hours_personal_errands: Number(value),
            })
        "
        input-type="number"
      />
      <div class="tw-col-span-2 tw-flex tw-items-center">
        <p class="tw-m-0 tw-font-roboto tw-text-sm">Hacer vueltas personales</p>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
